export default __webpack_public_path__ + "static/media/wkrecajacepo.d8cccc71.jpeg";